import isNumber from '@/shared/utils/is-number';

export default function isValidLatitude(latitude: unknown): boolean {
  return isNumber(latitude) && latitude >= -90 && latitude <= 90;
}
